/** Placeholder leaf for booklet spreads when interior page count is odd. */
export function BlankMenuPage() {
  return (
    <article
      className="menu-page menu-page--blank"
      aria-hidden="true"
      data-menu-blank
    />
  )
}
